import { useNavigate } from "@tanstack/react-router";
import { Button, type ButtonProps, DropdownMenu, type DropdownMenuProps } from "@bookingcom/bui-react";
import { AccountCreateIcon, SignOutIcon } from "@bookingcom/bui-assets-react/streamline";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { useAuth } from "../../hooks/useAuth";
import { HeaderAvatar } from "./HeaderAvatar";
import { HeaderLayout } from "./HeaderLayout";

export const Header = () => {
  const i18n = useI18n();
  const { logout, user, isLoading, isAdmin } = useAuth();
  const navigate = useNavigate();

  const dropdownMenuItems: DropdownMenuProps["items"] = [
    ...(isAdmin
      ? [
          {
            icon: AccountCreateIcon,
            text: i18n.trans(t("flights_airline_portal_superuser_view_header_bar_user_action_add_new")),
            onChoose: () => navigate({ to: "/add-user" }),
          },
        ]
      : []),
    {
      icon: SignOutIcon,
      text: i18n.trans(t("flights_airline_portal_header_bar_user_action_sign_out")),
      onChoose: () => logout({ logoutParams: { returnTo: window.location.origin } }),
    },
  ];

  return (
    <HeaderLayout
      actions={
        <DropdownMenu items={dropdownMenuItems} position="bottom-end">
          {(attributes: ButtonProps["attributes"]) => (
            <Button ariaLabel="User menu" variant="tertiary-inherit" attributes={attributes} disabled={isLoading}>
              <HeaderAvatar name={user?.name} email={user?.email} avatarUrl={user?.picture} isLoading={isLoading} />
            </Button>
          )}
        </DropdownMenu>
      }
    />
  );
};
